export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/cib-logo.04086437.svg","height":652,"width":652,"blurWidth":0,"blurHeight":0};